
import DataTable from '@/components/DataTable/index.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import UserPicker from '@/components/UserPicker/UserPicker.vue'
import FinancialPlan from '@/models/FinancialPlan'
import ViewModel from '@/models/ViewModel'
import WebMessage from '@/models/WebMessage'
import { currencyMask, percentageMask } from '@/models/interface/Masks'
import { groupBy } from 'lodash'
import moment from 'moment'
import {
  Component, Prop, Ref, Vue,
} from 'vue-property-decorator'
import FinancialPlanProductModule from '@/models/FinancialPlanProductModule'
import FinancialPlanReforecast from '@/models/FinancialPlanReforecast'
import DropArea from '@/components/DropArea/DropArea.vue'
import { read, utils } from 'xlsx'
import SalesRepConsolidateTable from './SalesRepConsolidateTable.vue'

@Component({
  components: {
    IconAction,
    DataTable,
    FormInput,
    UserPicker,
    SalesRepConsolidateTable,
    DropArea,
  },
})
export default class ReforecastEditModal extends ViewModel {
  @Ref() public validator!: any

  @Prop({ default: 0 })
  public year!: number

  @Prop({ default: false })
  public modal!: boolean

  public reload_drop_down_area: boolean = false

  public used_value: any = 0

  public parent: FinancialPlanReforecast = new FinancialPlanReforecast()

  public increment: number = 0

  public item: any = []

  public goalModule = new FinancialPlanProductModule()

  public can_collapse: boolean = false

  public loading: boolean = false

  public goal_refs: any = []

  public locked_items: any = []

  public locked_values: any = []

  public is_editing: boolean = true

  public import_status: string = ''

  public collapsed_groups: any = {
    ssl: false,
    ccl: false,
  }

  public top_header_fields: any = [
    {
      key: 'month',
      label: '',
      sortable: false,
      filter: false,
      show: true,
      style: 'width: 300px',
      thClass: 'text-start',
      colspan: 1,
    },
    {
      key: 'ssl',
      label: 'SSl',
      sortable: false,
      filter: false,
      show: true,
      colspan: 8,
      class: 'align-middle text-center border',
    },
    {
      key: 'home',
      label: 'Home',
      sortable: false,
      filter: false,
      show: true,
      colspan: 8,
      class: 'align-middle text-center border',
    },
    {
      key: 'ccl',
      label: 'CCl',
      sortable: false,
      filter: false,
      show: true,
      colspan: 7,
      class: 'align-middle text-center border',
    },
    {
      key: 'total',
      label: '',
      sortable: false,
      filter: false,
      show: true,
    },
  ]

  public sub_header_fields: any = [
    {
      key: 'month',
      label: '',
      show: true,
      class: 'align-middle text-left border',
    },

    {
      key: 'east_ssl',
      label: 'East',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'west_ssl',
      label: 'west',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'midwest_ssl',
      label: 'midwest',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'national_ssl',
      label: 'national',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'third_party_ssl',
      label: '3rd Party',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'political_ssl',
      label: 'Political',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'programmatic_ssl',
      label: 'Programmatic',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'total_ssl',
      label: 'total',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'east_home',
      label: 'East',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'west_home',
      label: 'west',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'midwest_home',
      label: 'midwest',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'national_home',
      label: 'national',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'third_party_home',
      label: '3rd Party',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'political_home',
      label: 'Political',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'programmatic_home',
      label: 'Programmatic',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'total_home',
      label: 'total',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'east_ccl',
      label: 'East',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'west_ccl',
      label: 'west',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'midwest_ccl',
      label: 'midwest',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'national_ccl',
      label: 'national',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'third_party_ccl',
      label: '3rd Party',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'political_ccl',
      label: 'Political',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'programmatic_ccl',
      label: 'Programmatic',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'total_ccl',
      label: 'total',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
    {
      key: 'total',
      label: 'total',
      show: true,
      style: 'width: 200px',
      class: 'align-middle text-center border',
    },
  ]

  public temp_goal: any = []

  public saving: boolean = false

  public create_new: boolean = true

  public loaded_data: any = []

  public import_errors: any = []

  public import_error_type: string = 'warning'

  public failed_import: boolean = false

  public viewing: any = {
    main_table: true,
  }

  public file_name: string = ''

  public imported_file_row_keys: any = null

  public get loading_state() {
    return this.loading || this.saving || !this.ready
  }

  public get masks() {
    return {
      currency: currencyMask,
      percentage: percentageMask,
    }
  }

  public get header_fields() {
    return this.top_header_fields.filter((item: any) => item.show)
  }

  public get sub_head_fields() {
    return this.sub_header_fields.filter((item: any) => item.show)
  }

  public ready: any = false

  public get local_modal() {
    return this.modal
  }

  public set local_modal(val) {
    this.$emit('update:modal', val)
  }

  public mounted() {
    // this.setMonthTable()
    // let financial = new FinancialPlan()
    // this.sub_header_fields = financial.bulk_year_sub_head_fields
    // this.top_header_fields = financial.bulk_year_fields
  }

  public searchMonths(arr: any, month: string, product: string, return_undef = false) {
    let found = arr.filter(a => {
      let splited = a.period_start_at.split('T')
      return moment(splited[0]).format('MMMM') === month && a.product === product
    })
    if (!found && !return_undef) return { goal: null }
    return found
  }

  public searchMonth(arr: any, month: string, product: string, region: any, return_undef = false) {
    let found = arr.find(a => {
      let splited = a.period_start_at.split('T')
      return moment(splited[0]).format('MMMM') === month && a.product === product && a.region
    })
    if (!found && !return_undef) return { goal: 0 }
    return found
  }

  public setMonthTable(pre_load: boolean = true) {
    let months = moment.months().map((monthName: string) => {
      let obj: any = {
        month: monthName,
        ccl: {
          east: 0,
          west: 0,
          midwest: 0,
          national: 0,
          third_party: 0,
          political: 0,
          programmatic: 0,
          total: 0,
        },
        ssl: {
          east: 0,
          west: 0,
          midwest: 0,
          national: 0,
          third_party: 0,
          political: 0,
          programmatic: 0,
          total: 0,
        },
        home: {
          east: 0,
          west: 0,
          midwest: 0,
          national: 0,
          third_party: 0,
          political: 0,
          programmatic: 0,
          total: 0,
        },
        total: 0,
      }
      let ssl_goals = this.searchMonths(this.goal_refs, monthName, 'ssl')
      let ccl_goals = this.searchMonths(this.goal_refs, monthName, 'ccl')
      let home_goals = this.searchMonths(this.goal_refs, monthName, 'home')

      ssl_goals = ssl_goals.map((ssl_goal: any) => ({
        [ssl_goal.region]: ssl_goal.goal,
      }))
      ccl_goals = ccl_goals.map((ccl_goal: any) => ({
        [ccl_goal.region]: ccl_goal.goal,
      }))

      home_goals = home_goals.map((home_goal: any) => ({
        [home_goal.region]: home_goal.goal,
      }))

      Object.assign(obj.ssl, ...ssl_goals)
      Object.assign(obj.ccl, ...ccl_goals)
      Object.assign(obj.home, ...home_goals)

      return obj
    })

    this.temp_goal = months

    this.ready = true
  }

  public cancelEdition() {
    this.local_modal = false
    this.saving = false
    this.parent = new FinancialPlanReforecast()
    this.used_value = 0
    this.create_new = false
    this.is_editing = false
    this.goal_refs = []
  }

  public async saveAll() {
    this.saving = true
    this.loading = true
    let payload: any = this.temp_goal
    if (this.parent?.id) {
      payload = []
      // format temp_goal to update
      this.temp_goal.forEach((goal: any) => {
        let found_ssl = this.searchMonths(this.goal_refs, goal.month, 'ssl', true)
        let found_ccl = this.searchMonths(this.goal_refs, goal.month, 'ccl', true)
        let found_home = this.searchMonths(this.goal_refs, goal.month, 'home', true)

        found_ssl.forEach((ssl: any) => {
          payload.push({
            id: ssl.id,
            goal: goal.ssl[ssl.region],
          })
        })
        found_ccl.forEach((ccl: any) => {
          payload.push({
            id: ccl.id,
            goal: goal.ccl[ccl.region],
          })
        })
        found_home.forEach((home: any) => {
          payload.push({
            id: home.id,
            goal: goal.home[home.region],
          })
        })
      })
    }

    let obj: any = {
      name: this.parent.name,
      description: this.parent.description,
      payload,
    }

    FinancialPlanReforecast.save(obj, this.year, this.parent?.id || null)
      .then(response => {
        this.loading = false
        this.$emit('saved')
        this.cancelEdition()
      })
      .catch(() => {
        this.loading = false
        this.saving = false
      })
  }

  public async distibuteGoal(action: string, increment: any = null) {
    if (!this.is_editing && !this.create_new) return
    this.loading = true

    let value_use: number = Number(this.used_value.toFixed(2))

    let copy: any = JSON.parse(JSON.stringify(this.temp_goal))

    await this.goalModule
      .distibuteGoal(copy, action, increment, value_use)
      .then(updated_vals => {
        Vue.set(this, 'temp_goal', updated_vals)

        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  }

  public importFile(files: FileList) {
    this.imported_file_row_keys = null
    if (!files || files.length == 0) return

    if (files.length > 1) {
      WebMessage.error('You can only upload one order file at a time.')
      return
    }

    let file = files[0]

    if (file) {
      this.processFile(file)
    }
  }

  public map_keys: any = {
    'West Coast': 'west',
    'East Coast': 'east',
    Midwest: 'midwest',
    National: 'national',
    'Third Party': 'third_party',
    '3rd Party': 'third_party',
    Political: 'political',
    Programmatic: 'programmatic',
  }

  public processFile(file: any) {
    this.loading = true
    this.setMonthTable()

    this.$emit('update:confirming', true)
    this.import_status = 'Loading file...'

    this.$bvModal.show('import-loader')
    this.loaded_data = []
    this.import_errors = []
    this.failed_import = false

    let reader = new FileReader()
    reader.onload = async (e: any) => {
      let bytes = new Uint8Array(e.target.result)

      this.file_name = file.name

      /* read workbook */
      let wb = read(bytes)

      if (wb.SheetNames.length != 1) {
        this.import_errors.push('You should have only one sheet in the file.')
        this.import_status = 'failed'
        this.failed_import = true
        return
      }

      // Temporary Fix for importing data
      // This is a workaround to allow importing data from a file after its been modified via excel.
      utils.sheet_add_dom(wb.Sheets[wb.SheetNames[0]], document.createElement('div'))
      const data = utils.sheet_to_json<any>(wb.Sheets[wb.SheetNames[0]])

      this.import_status = 'Validating file...'

      this.import_status = 'Extracting data...'

      let months: any = {}

      let unused_cols = [
        '__EMPTY_2',
        '__EMPTY_8',
        '__EMPTY_12',
        '__EMPTY_16',
        '__EMPTY_20',
        '__EMPTY_21',
        '__EMPTY_22',
        '__EMPTY_23',
        '__EMPTY_24',
        '__EMPTY_25',
      ]
      for (const month in data[0]) {
        if (!unused_cols.includes(month)) {
          months[month] = data[0][month]
        }
      }

      let filtered_data = [...data]

      filtered_data.splice(22, 8)
      filtered_data.splice(20, 1)

      let map_products: any = {
        'SSL Out-of-Market': 'ssl',
        'SSL In-Market': 'home',
        CCL: 'ccl',
        National: 'national',
      }

      let base_arrays: any = {
        ccl: [],
        ssl: [],
        home: [],
        total: 0,
      }
      let imported: any = {
        january: base_arrays,
        february: base_arrays,
        march: base_arrays,
        april: base_arrays,
        may: base_arrays,
        june: base_arrays,
        july: base_arrays,
        august: base_arrays,
        september: base_arrays,
        october: base_arrays,
        november: base_arrays,
        december: base_arrays,
      }

      let start_position = 0
      let limit_to_search_sheet_rows = 19
      let third_party_col_indx = 20
      let month_names = Object.keys(imported)
      let month_in_obj: any = {}

      Object.keys(months)
        .slice(0, 12)
        .forEach(key => {
          month_in_obj[key] = month_names.find(_month =>
            _month.includes(months[key].toLowerCase()))
        })

      let temp: any = []
      let copy = JSON.parse(JSON.stringify(this.temp_goal))
      while (start_position < limit_to_search_sheet_rows) {
        let ranged: any = await this.getInRange(filtered_data, start_position)

        if (!ranged || !ranged.ranges || ranged.ranges[1] === -1) {
          // @no-console

          break // Exit if invalid data is returned
        }

        let { items, ranges } = ranged
        // loop_months is items without the last item
        const loop_months = items.slice(1, items.length - 1)
        let region = items[items.length - 1]

        for (let row of loop_months) {
          let product = map_products[row.__EMPTY_2.trim()]

          const _region = this.map_keys[region.__EMPTY_2.trim()]

          for (const col in row) {
            if (month_in_obj[col]) {
              temp.push({
                col,
                value: row[col],
                month: month_in_obj[col],
                product,
                region: _region,
              })
            }
          }
        }

        start_position = ranges[1] + 1 // Ensure we move past the last processed item
      }

      let grouped_by_month = groupBy(temp, 'month')

      for (const month in grouped_by_month) {
        const month_data = grouped_by_month[month]
        const groupByProduct = groupBy(month_data, 'product')
        let bulk_month_index = copy.findIndex(
          (item: any) => item.month.toLowerCase() === month.toLowerCase(),
        )

        for (const product in groupByProduct) {
          const product_data = groupByProduct[product]

          product_data.forEach(d => {
            copy[bulk_month_index][d.product][d.region] = Math.round(d.value)
            if (product !== 'ssl') {
              // set third_party to 0
              copy[bulk_month_index][d.product].third_party = 0
            }
          })

          let month_key: any = Object.keys(month_in_obj).find(key => month_in_obj[key] === month)

          if (product === 'ssl') {
            copy[bulk_month_index][product].third_party = Math.round(
              filtered_data[third_party_col_indx][month_key],
            )
          }
        }
      }
      this.temp_goal = null

      Vue.set(this, 'temp_goal', copy)

      // @ts-ignore
      this.used_value = this.goalModule.calculateAllMonthTotals(this.temp_goal)

      this.import_status = 'done'

      this.import_status = ''

      this.loading = false
    }
    reader.readAsArrayBuffer(file)
    // force clear input.type=file in the dom

    this.reload_drop_down_area = true

    setTimeout(() => {
      this.reload_drop_down_area = false
    }, 200)
  }

  public async getInRange(arr: Array<any>, start: number) {
    return new Promise((resolve, reject) => {
      resolve({
        ranges: [start, start + 4],
        items: arr.slice(start, start + 5),
        next: start + 4 + 1,
      })
    })
  }
}
